






import Vue from 'vue'
import * as player from '@vimeo/player'
export default Vue.extend({
  props: {
    id: {
      type: String
    },
    maxHeight: {
      type: Number
    }
  },
  data() {
    return {
      height: '320px'
    }
  },
  methods: {
    setHeight() {
      const vimeo = document.getElementById(this.id)
      if (vimeo) {
        const height = vimeo.offsetWidth * 9/16
        this.height = this.maxHeight ? Math.min(height, this.maxHeight) + 'px' : height + 'px'
      }
    }
  },
  mounted() {
    this.setHeight()
    window.addEventListener('resize', () => {
      this.setHeight()
    })
  }
})
